import paymentApi from '../../utils/paymentApi';

function unwrap(response) {
  const body = response?.data;
  if (Number(body?.code) !== 200) {
    throw new Error(body?.message || '积分消耗顺序服务暂不可用');
  }
  return body?.data && typeof body.data === 'object' ? body.data : {};
}

export async function getCreditOrder() {
  return unwrap(await paymentApi.get('/credit-account/order/list'));
}

export async function saveCreditOrder(payload) {
  return unwrap(await paymentApi.post('/credit-account/order/update', payload));
}

export async function getTeamCreditOrder() {
  return unwrap(await paymentApi.get('/team/credit-order/list'));
}

export async function saveTeamCreditOrder(payload) {
  return unwrap(await paymentApi.post('/team/credit-order/update', payload));
}
